import React, { useMemo, useState } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { Url, URLS } from '@wix/da-url';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import { BiData } from '@wix/da-bi/pkg/events';
import ButtonWithContextMenuOnHover from '../../../Dropdown/Preset/ButtonWithContextMenuOnHover';
import NewIndicatorDot from '../../../NewIndicatorDot';
import moreMenuStyles from './MoreMenu.scss';
import siteHeaderStyles from '../SiteHeaderDesktop.scss';
var MoreMenu = function (_a) {
    var className = _a.className, iconClassName = _a.iconClassName, hasNewContent = _a.hasNewContent, markMoreMenuSeen = _a.markMoreMenuSeen;
    var t = useTranslation().t;
    var _b = useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var items = useMemo(function () { return [
        {
            key: 'groups',
            label: t('siteHeader.groups'),
            link: Url.buildFromPath(URLS.GROUPS),
            biData: BiData({
                evid: 700,
                link_name: 'groups',
                link_url: Url.buildFromPath(URLS.GROUPS),
            }),
        },
        {
            key: 'shop',
            label: t('siteHeader.shop'),
            link: Url.buildFromPath(URLS.SHOP),
            biData: BiData({
                evid: 700,
                link_name: 'shop',
                link_url: Url.buildFromPath(URLS.SHOP),
            }),
        },
        {
            key: 'forum',
            label: t('siteHeader.forum'),
            link: Url.buildFromPath(URLS.FORUM),
            biData: BiData({
                evid: 700,
                link_name: 'forum',
                link_url: Url.buildFromPath(URLS.FORUM),
            }),
        },
        {
            key: 'whatsNew',
            label: t('siteHeader.whatsNew'),
            link: URLS.TEAM,
            target: '_blank',
            biData: BiData({
                evid: 700,
                link_name: 'whatsNew',
                link_url: URLS.TEAM,
            }),
        },
        {
            key: 'daProtect',
            label: t('siteHeader.daProtect'),
            newTag: true,
            link: URLS.PROTECT,
            target: '_blank',
            biData: BiData({
                evid: 700,
                link_name: 'protect',
                link_url: URLS.PROTECT,
            }),
        },
    ]; }, [t]);
    return (React.createElement(ButtonWithContextMenuOnHover, { items: items, className: c(moreMenuStyles['root'], isOpen && siteHeaderStyles['toggled'], className), popperClassName: moreMenuStyles['popper'], "aria-label": t('siteHeader.more'), onOpen: function () {
            setIsOpen(true);
            hasNewContent && markMoreMenuSeen();
        }, onClose: function () {
            setIsOpen(false);
        } },
        React.createElement(EllipsisIcon, { className: iconClassName, disableDefaultColors: true }),
        hasNewContent && (React.createElement(NewIndicatorDot, { className: moreMenuStyles['new-indicator-dot'] }))));
};
MoreMenu.displayName = 'MoreMenu';
export default MoreMenu;
//# sourceMappingURL=MoreMenu.js.map